export default {"src":"/_next/static/media/AVGO.b7b62022.svg","height":18,"width":18};